/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteUserSessionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'
import {DeleteUserSessionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'


export const deleteUserSession = (request: DeleteUserSessionRequest, options?: CashRequestOptions) => post<DeleteUserSessionRequest, DeleteUserSessionResponse>("/cash-app/goose-cash/v3/delete-user-session", request, {...options, rejectOnError: true })